import OriginEmpty from './empty.vue';
import OriginNoSearchData from './no-search-data.vue';
OriginEmpty.NoSearchData = OriginNoSearchData;
export default OriginEmpty as typeof OriginEmpty & {
  readonly NoSearchData: typeof OriginNoSearchData;
};
